module.exports = __webpack_public_path__ + "img/csr-4.e6a76265.jpg";